/**
 * Copiar texto para a área de transferência (item 4 do pedido de 19/10: link wa.me da troca de óleo).
 *
 * 1º navigator.clipboard.writeText (exige HTTPS, que os dois ambientes têm);
 * plano B: textarea fora da tela + document.execCommand("copy") (navegador antigo, contexto sem
 * permissão ou clipboard recusado). Devolve true/false; nunca lança erro.
 */
export async function copiarTexto(texto) {
  const t = String(texto ?? "");
  try {
    const seguro = typeof window === "undefined" || window.isSecureContext !== false;
    if (seguro && typeof navigator !== "undefined" && navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(t);
      return true;
    }
  } catch (_) { /* cai no plano B */ }
  return copiarPorTextarea(t);
}

/** Plano B: seleciona o texto num textarea temporário e usa o comando "copy" do navegador. */
export function copiarPorTextarea(texto) {
  if (typeof document === "undefined" || !document.body) return false;
  let ta = null;
  try {
    ta = document.createElement("textarea");
    ta.value = String(texto ?? "");
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.left = "0";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { ta.setSelectionRange(0, ta.value.length); } catch (_) { /* iOS antigo */ }
    return typeof document.execCommand === "function" ? !!document.execCommand("copy") : false;
  } catch (_) {
    return false;
  } finally {
    if (ta && ta.parentNode) ta.parentNode.removeChild(ta);
  }
}
